import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/calendar/EventTournamentCalendar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarImage"] */ "/opt/buildhome/repo/src/components/ui/avatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs","TabsList","TabsTrigger","TabsContent"] */ "/opt/buildhome/repo/src/components/ui/tabs.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/ui/tooltip.tsx");
